export default __webpack_public_path__ + "static/media/IMG-20241005-WA0034.5c598409.jpg";